import { render, staticRenderFns } from "./YZRegister.vue?vue&type=template&id=6ffc9d26&scoped=true&"
import script from "./YZRegister.vue?vue&type=script&lang=js&"
export * from "./YZRegister.vue?vue&type=script&lang=js&"
import style0 from "./YZRegister.vue?vue&type=style&index=0&id=6ffc9d26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffc9d26",
  null
  
)

export default component.exports